"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Image from "next/image";

import "swiper/css";

const comfortsData = [
    {
        title: "Male & Female Toilets / Showers",
        icon: "/assets/img/comf-1.svg",
    },
    {
        title: "Smart Lockers",
        icon: "/assets/img/comf-2.svg",
    },
    {
        title: "Parking Lot",
        icon: "/assets/img/comf-3.svg",
    },
    {
        title: "Wheel Chair / Stretcher",
        icon: "/assets/img/comf-4.svg",
    },
    {
        title: "Changing Rooms",
        icon: "/assets/img/comf-5.svg",
    },
    {
        title: "Medical Room",
        icon: "/assets/img/comf-6.svg",
    },
    {
        title: "Mother Feeding Room",
        icon: "/assets/img/comf-7.svg",
    },
    {
        title: "Differently Abled Friendly",
        icon: "/assets/img/comf-8.svg",
    },
    {
        title: "Footwear Storages",
        icon: "/assets/img/comf-9.svg",
    },
    {
        title: "Drinking Water",
        icon: "/assets/img/comf-10.svg",
    }
];

export default function ParksideComforts() {
    return (
        <section className="parkside-comforts-section">
            <div className="container-fluid parkside-comforts-container">
                <div className="row justify-content-center">
                    <div className="col-lg-11">
                        <div className="parkside-comforts-heading text-center">
                            <p style={{ fontFamily: 'Chewy, system-ui', paddingBottom: '30px' }}>
                                Design to feel comfortable
                            </p>
                            <h2>Facilities</h2>

                        </div>

                        <div className="parkside-comforts-slider-wrap">
                            <Swiper
                                modules={[Autoplay]}
                                loop={true}
                                speed={700}
                                spaceBetween={18}
                                slidesPerView={2.2}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                breakpoints={{
                                    576: {
                                        slidesPerView: 2,
                                        spaceBetween: 18,
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                    992: {
                                        slidesPerView: 5,
                                        spaceBetween: 22,
                                    },
                                    1200: {
                                        slidesPerView: 6,
                                        spaceBetween: 24,
                                    },
                                    1400: {
                                        slidesPerView: 8,
                                        spaceBetween: 24,
                                    },
                                }}
                                className="parkside-comforts-swiper"
                            >
                                {comfortsData.map((item, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="comfort-card text-center">
                                            <div className="comfort-icon-circle">
                                                <object data={item.icon} type="image/svg+xml" width={140}
                                                    height={140}></object>
                                            </div>
                                            <h4>{item.title}</h4>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}